import * as Yup from "yup";

import { Modal, OfficeButton } from "components";
import {
  SendTreatyClaimNotification,
  SendTreatyClaimNotificationVariables,
} from "_graphql/mutation/__generated__/SendTreatyClaimNotification";

import { SendEmailForm } from "components/forms";
import { sendTreatyClaimNotification } from "_graphql/visal/mutations/offers";
import toast from "react-hot-toast";
import { useAppSearch } from "_graphql/cache/auth";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { wrapClick } from "utils";

const validationSchema = Yup.object().shape({
  copied_emails: Yup.array()
    .of(Yup.string().email("Invalid email format"))
    .required("At least one email is required"),
  subject: Yup.string().required("Subject is required"),
  message: Yup.string().required("Message is required"),
  attachments: Yup.array()
    .of(
      Yup.object().shape({
        file_path: Yup.string().required("File path is required"),
      })
    )
    .notRequired(), // Attachments are optional
});

export default function SendClaimContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useAppSearch();
  const [send, { loading }] = useMutation<
    SendTreatyClaimNotification,
    SendTreatyClaimNotificationVariables
  >(sendTreatyClaimNotification, {
    refetchQueries: ["GetTreaties"],
  });

  const form = useFormik({
    initialValues: {
      copied_emails: [],
      subject: "",
      message: "",
      attachments: [],
    },
    validationSchema,
    onSubmit: (values) => {
      send({
        variables: {
          emailData: {
            treaty_id: searchParams?.id || "",
            copied_emails: values.copied_emails || [],
            subject: values.subject || "",
            message_content: values.message,
            attachment:
              values.attachments?.map((file: any) => file?.file_path) || [],
          },
        },
      })
        .then(({ data }) => {
          if (data?.sendTreatyClaimNotification) {
            toast.success("Claim notification sent successfully");
            setOpen(false);
          } else {
            toast.error("Failed to send claim notification");
          }
        })
        .catch((error) => {
          toast.error("An error occurred while sending the claim notification");
        });
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="4xl"
      title="Send Claim Notification"
      description="Provide the details to send a claim notification"
      renderActions={() => (
        <OfficeButton
          disabled={loading}
          onClick={wrapClick(form.handleSubmit)}
          variant="primary"
          size="sm"
        >
          {loading ? "Sending" : "Send Claim Notification"}
        </OfficeButton>
      )}
    >
      {/* {JSON.stringify(form.)} */}
      <SendEmailForm form={form} />
    </Modal>
  );
}
